const QR_SIZE = 220

export function buildAssetQrPayload(asset) {
    if (!asset || typeof asset !== 'object') return ''
    return JSON.stringify({
        assetId: asset.AssetId || null,
        assetTag: asset.AssetTag || '',
        assetName: asset.AssetName || asset.assetName || '',
    })
}

export function getAssetQrImageUrl(payload) {
    const safe = encodeURIComponent(payload || '')
    return `https://api.qrserver.com/v1/create-qr-code/?size=${QR_SIZE}x${QR_SIZE}&data=${safe}`
}

export function parseAssetQrPayload(raw) {
    if (!raw || typeof raw !== 'string') return {}
    try {
        const parsed = JSON.parse(raw)
        return {
            assetId:
                parsed?.assetId != null ? String(parsed.assetId).trim() : '',
            assetTag: parsed?.assetTag ? String(parsed.assetTag).trim() : '',
            assetName: parsed?.assetName ? String(parsed.assetName).trim() : '',
        }
    } catch {
        return { assetId: '', assetTag: raw.trim(), assetName: '' }
    }
}

export function printAssetLabel({ asset, qrUrl }) {
    const name = asset?.AssetName || asset?.assetName || 'Asset'
    const tag =
        asset?.AssetTag || asset?.assetId || asset?.AssetId || 'N/A'
    const w = window.open('', '_blank', 'width=520,height=700')
    if (!w) return

    w.document.write(`
        <html>
          <head>
            <title>Print Asset Label</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 24px; }
              .label { border: 1px solid #333; border-radius: 8px; padding: 16px; max-width: 360px; }
              .title { font-size: 18px; font-weight: 700; margin-bottom: 6px; }
              .meta { font-size: 14px; margin-bottom: 12px; color: #333; }
              .qr { width: 220px; height: 220px; display: block; }
            </style>
          </head>
          <body>
            <div class="label">
              <div class="title">${name}</div>
              <div class="meta">ID: ${tag}</div>
              <img class="qr" src="${qrUrl}" alt="Asset QR" />
            </div>
          </body>
        </html>
    `)
    w.document.close()
    w.focus()
    w.print()
}
